import gameConsts from './gameConsts';
import RoadObject from './RoadObject';

let coordItems;

export default class Obstacle extends RoadObject {
  constructor({ game, player, values, road, name, collideItem, spikes }) {
    super({
      game,
      player,
      values,
      road,
      name,
      collideItem,
      spikes,
    });

    this._spikes = spikes;
    this.collideItem = collideItem;
  }
  static randomCoord(items) {
    const keys = Object.keys(items);
    const random = keys[Math.floor(keys.length * Math.random())];

    return items[random];
  }
  get _areaValues() {
    const values = {
      width: this._road.part / this._scaleValue,
      height: this.defaultHeight + (2.6 * this._player.defaultHeight),
    };
    values.offsetX = -(values.width - this.width) / 2;

    return values;
  }
  get _collision() {
    return this._game.physics.arcade.collide(this._player.item, this.item);
  }
  get _minX() {
    return this._road.item.position.x + this._road.borderWidth + (this.width > this._road.part ? 0 : (this._road.part - this.width) / 2);
  }
  get _middleX() {
    return this._minX + this._road.part;
  }
  get _maxX() {
    return (this._road.item.position.x + this._road.width) - (this.width > this._road.part ? this.width : (this._road.part + this.width) / 2) - this._road.borderWidth;
  }
  get coords() {
    return { minX: this._minX, middleX: this._middleX, maxX: this._maxX };
  }
  _setRandomX() {
    coordItems = { ...this.coords };

    if (this._spikes.isActive) {
      if (this._spikes.item.x === this._spikes.coords.minX) {
        delete coordItems.maxX;
        if (this._name === 'movingEnemy') {
          delete coordItems.middleX;
        }
      } else if (this._spikes.item.x === this._spikes.coords.maxX) {
        delete coordItems.minX;
        if (this._name === 'movingEnemy') {
          delete coordItems.middleX;
        }
      }
    }
    this._setX(coordItems);
  }
  _setX(items) {
    this.item.x = Obstacle.randomCoord(items);
  }
  _deleteArea() {
    this.item.body.setSize(this._defaultWidth, this.defaultHeight, 0, this._bodyOffsetY);
  }
  _setArea() {
    const offsetY = -(this._areaValues.height - this.defaultHeight) + this._bodyOffsetY;

    this.item.body.setSize(this._areaValues.width, this._areaValues.height, this._areaValues.offsetX, offsetY);
  }
  _checkCollisionArea() {
    if (Math.abs(this.item.y - this.collideItem.item.y) <= 3 * this._player.height) {
      this.item.y -= gameConsts.GAME_HEIGHT / 2;
      this._checkCollisionArea();
    }
    this.isActive = true;
  }
  _collidedShield() {
    if (this._collision && this._playerData.isShield) {
      this.item.y = -gameConsts.GAME_HEIGHT;
      this.isActive = false;
    }
  }
  moveStatic() {
    this.item.y -= this._deltaSpeed;
  }
  update() {
    if (this.isActive) {
      this._move(); // объект едет
      if (this.item.y >= 40 && this.item.body.width !== this.width) {
        this._deleteArea();
      }
      this._checkOutScreen(); // убираем эктив, если уехал за низ экрана
    } else {
      this._activate('obstacle'); // создаём в рандомном месте за экраном сверху, задаём эктив
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/Obstacle.js